import React, {useEffect, useRef, useState} from "react";
import {AutoComplete} from "primereact/autocomplete";
import {Dropdown} from "primereact/dropdown";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";

const STANDARD_UMKREIS_KM = 50;

/**
 * Formatiert die vom Backend gelieferte, gerundete Entfernung (entfernungKm). undefined, wenn keine Entfernung vorhanden ist.
 */
export function formatEntfernung(entfernungKm) {
    if( entfernungKm === null || entfernungKm === undefined) {
        return undefined;
    }
    // Mittelpunkt zu Mittelpunkt der PLZ, daher nur ungefähr
    return entfernungKm < 1 ? "< 1 km" : "ca. " + entfernungKm + " km";
}

/**
 * Eingabe von PLZ oder Ortsname und Umkreis. Zu einem Ortsnamen werden Orte vorgeschlagen, die Auswahl belegt die PLZ vor.
 * Meldet über onChange {plz, km} oder null, wenn keine Umkreissuche aktiv ist. Gefiltert wird im Backend.
 */
export default function UmkreissucheComp({onChange, plzUnbekannt}) {

    const [eingabe, setEingabe] = useState("");
    const [vorschlaege, setVorschlaege] = useState([]);
    const [plz, setPlz] = useState(undefined);
    const [km, setKm] = useState(STANDARD_UMKREIS_KM);
    // die erlaubten Umkreise legt das Backend fest
    const [umkreise, setUmkreise] = useState([]);
    // nur die Antwort zum letzten Suchtext übernehmen
    const aktuelleOrtssuche = useRef("");

    useEffect(() => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.public + "/geo/umkreise",
            json => {
                const erlaubteKm = json || [];
                setUmkreise(erlaubteKm.map(wert => ({label: wert + " km", value: wert})));
                if( erlaubteKm.length > 0 && !erlaubteKm.includes(STANDARD_UMKREIS_KM)) {
                    // der Standard wird vom Backend nicht angeboten, dann den kleinsten Umkreis vorbelegen
                    setKm(erlaubteKm[0]);
                }
            },
            responseNotOk => {
                console.log(responseNotOk.message);
            },
            error => {
                console.log(error.message);
            });
    }, []);

    const changePlz = (neuePlz) => {
        setPlz(neuePlz);
        onChange(neuePlz ? {plz: neuePlz, km: km} : null);
    }

    const changeEingabe = (wert) => {
        if( wert !== null && typeof wert === "object") {
            // Vorschlag ausgewählt
            setEingabe(wert.plz + " " + wert.ort);
            changePlz(wert.plz);
            return;
        }
        const text = wert || "";
        if( /^\d*$/.test(text)) {
            const neuePlz = text.substring(0, 5);
            setEingabe(neuePlz);
            changePlz(neuePlz.length === 5 ? neuePlz : undefined);
            return;
        }
        // Ortsname, die Umkreissuche startet erst mit der Auswahl eines Vorschlags
        setEingabe(text);
        changePlz(undefined);
    }

    const sucheOrte = (suche) => {
        aktuelleOrtssuche.current = suche;
        if( /^\d*$/.test(suche)) {
            setVorschlaege([]);
            return;
        }
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.public + "/geo/orte?suche=" + encodeURIComponent(suche),
            json => {
                if( aktuelleOrtssuche.current !== suche) {
                    return;
                }
                setVorschlaege(json || []);
            },
            responseNotOk => {
                setVorschlaege([]);
                console.log(responseNotOk.message);
            },
            error => {
                setVorschlaege([]);
                console.log(error.message);
            });
    }

    const vorschlagTemplate = (vorschlag) => {
        return <div>
            {vorschlag.plz} {vorschlag.ort}<br/>
            <span style={{fontSize: 10, opacity: 0.6}}>{vorschlag.kreis}</span>
        </div>
    }

    const changeKm = (neueKm) => {
        setKm(neueKm);
        if( plz ) {
            onChange({plz: plz, km: neueKm});
        }
    }

    return <div style={{display: "flex", alignItems: "center"}}>
        <AutoComplete id="umkreisPlz" value={eingabe} suggestions={vorschlaege} placeholder={"PLZ oder Ort"}
                      completeMethod={(e) => sucheOrte(e.query.trim())} minLength={3} delay={300}
                      itemTemplate={vorschlagTemplate} selectedItemTemplate={(vorschlag) => vorschlag.plz + " " + vorschlag.ort}
                      onChange={(e) => changeEingabe(e.value)}
                      inputStyle={{width: 160}} style={{marginRight: 5}}/>
        <Dropdown value={km} options={umkreise} onChange={(e) => changeKm(e.value)} style={{width: 95}}/>
        {plz && plzUnbekannt && <span style={{color: "white", fontSize: 12, marginLeft: 10}}>PLZ unbekannt</span>}
    </div>
}
